import { LAYOUTS, type LayoutId } from "./layouts.ts"
import { setLayout } from "./workspaceStore.ts"

/** A tiny grid drawing of each layout, rendered from its CSS grid areas. */
function LayoutIcon({ areas }: { readonly areas: string }) {
  const rows = areas.match(/"([^"]+)"/g)?.map((row) => row.replace(/"/g, "").split(" ")) ?? []
  const names = [...new Set(rows.flat())]
  return (
    <span className="layout-icon" style={{ gridTemplateAreas: areas }} aria-hidden>
      {names.map((name) => <span key={name} style={{ gridArea: name }} />)}
    </span>
  )
}

export function LayoutPicker({ current }: { readonly current: LayoutId }) {
  return (
    <div className="button-group" role="group" aria-label="Chart layout">
      {LAYOUTS.map((layout) => (
        <button
          key={layout.id}
          type="button"
          title={layout.label}
          aria-label={layout.label}
          aria-pressed={layout.id === current}
          onClick={() => setLayout(layout.id)}
        >
          <LayoutIcon areas={layout.areas} />
        </button>
      ))}
    </div>
  )
}
